import {
  validateFkCompanyId,
  validateOldCompanyIdForFragment,
  validatePropertyIdForFragment,
} from "../utils/transferPropertyCompanyWizard"
import type { TransferProcessPageContext } from "../hooks/useTransferProcessPage"

/**
 * Keep wizard validators registered while other tabs are active (Angular keeps one FormGroup mounted).
 * Without this, `formState.isValid` on the Employee tab can block "Complete Transfer".
 */
export function TransferProcessHiddenFields({ ctx }: { ctx: TransferProcessPageContext }) {
  const { fragment, register } = ctx
  if (!fragment) return null

  const showEmailDomainFields = fragment !== "transfer_resident"

  return (
    <div data-testid="transfer-process-hidden-form-fields" className="hidden" aria-hidden>
      <input
        type="hidden"
        data-testid="transfer-process-form-hidden-fk-company-id"
        {...register("fk_company_id", {
          validate: validateFkCompanyId,
        })}
      />
      <input
        type="hidden"
        data-testid="transfer-process-form-hidden-old-company-id"
        {...register("old_company_id", {
          validate: (v) => validateOldCompanyIdForFragment(v, fragment),
        })}
      />
      <input
        type="hidden"
        data-testid="transfer-process-form-hidden-property-id"
        {...register("property_id", {
          validate: (v) => validatePropertyIdForFragment(v, fragment),
        })}
      />
      {showEmailDomainFields ? (
        <>
          <input type="hidden" {...register("updatedomain")} />
          <input type="hidden" {...register("newdomain")} />
        </>
      ) : null}
    </div>
  )
}
